module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-promotion-mobile-4d1f933f6e20f7938ab6051de2964260.webp";